// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
    --first-color: #155263;
    --second-color: #ff6f3c;
    --third-color: #ff9a3c;
    --fourth-color: #ffc93c;
}

.App {
  text-align: center;
  font-family: Roboto, 'Helvetica Neue', sans-serif;
  font-size: 11pt;
  /* background-color: #F0F0F0; */
}

input {
    text-align: right;
    width: 80px;
    font-family: Roboto, 'Helvetica Neue', sans-serif; /* monospace digits ; see alse <Text style={{fontVariant: ['tabular-nums']}}> */
}

button.cross {
    background-color: transparent;
    border-width: 0em;
    color: lightgrey;
}

button.cross:hover {
    color: grey;
}

button.cross:active {
    color: darkred;
}


.listingTable2 {
    td:nth-child(1) { text-align: left; };
    td:nth-child(2) { text-align: right; };
    td:nth-child(3) { text-align: right; };
}

#frequencyTable td,
#frequencyTable th {
    padding-left: 5px;
    padding-right: 5px;
    border-left: solid 1px lightgray;
}

#frequencyTable th {
    font-size: small;
    background-color: #F0F0F0;
}

#frequencyTable {
    border-collapse: collapse;
    margin-top: 5px;
    border: none;
    td:nth-child(1) { text-align: center; border: none;};
    td:nth-child(2) { text-align: right; };
    td:nth-child(3) { text-align: right; };
    td:nth-child(5) { text-align: right; };
    td:nth-child(6) { text-align: right; };

    th:nth-child(1) { text-align: center; border: none;};
    th:nth-child(2) { text-align: right; };
    th:nth-child(3) { text-align: right; };
    th:nth-child(5) { text-align: right; };
    th:nth-child(6) { text-align: right; };

    tr:nth-child(even) {
        background-color: #F9F9E1;
    }
}


table {
    padding: 0px;
    margin: 0px;
    border-collapse: collapse;
}

table th {
    font-weight: 300;
    padding-right: 3px;
    margin: 0px;
}

table td {
    margin: 0px;
    padding-left: 0px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 2px;
}

#formBins label {
    display: block;
    width: 100px;
    font-weight: 300;
    font-size: small;
}

#formBins > div {
    display: flex;
    flex-flow: row wrap;
}

#formBins p {
    text-align: right;
    margin: 0px;
    padding-bottom: 1.2px;
    padding-top: 1.2px;
    padding-right: 2px;
    padding-left: 2px;
    background-color: #F0F0F0;
    border: 1px solid grey;
    border-radius: 2px;
    width: 82px;
    box-sizing: content-box;
}

.freqIndicator {
    fill: lightskyblue;
    stroke: null;
}

.freqIndicatorDiv {
    background-color: lightskyblue;
    height: 12px;
}

div.card {
    background-color: #FEFEFE; /*var(--fourth-color);*/
    border-radius: 5px;
    box-shadow: 0px 1px 2px #AEAEAE;
    margin: 5px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-top: 0px;
    gap: 0px;
}

p.cardTitle {
    font-weight: 300;
    text-align: left;
    padding: 0px;
    margin-top: 2px;
}

.popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.popupWrapper {
    display: flex;
    align-items: flex-end;
}

.pig {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: end;
}

#formSettings > div {
    display: flex;
    flex-flow: row wrap;
}

#formSettings label {
    /*display: block;*/
    width: 100px;
    font-weight: 300;
    font-size: small;
    padding-right: 2px;
}

#formSettings > input {
    background-color: lightgray;
    padding-right: 2px;
    border: none;
}

/* todo solve either inheritance or composed class?*/
.tab-active {
  font-size: small;
  /*padding: 10px 60px;*/
  cursor: pointer;
  opacity: 0.6;
  background: white;
  border: 0;
  outline: 0;
  border-bottom: 2px solid grey;
opacity: 1;
}

.tab-inactive {
    font-size: small;
    /*padding: 10px 60px;*/
    cursor: pointer;
    opacity: 0.6;
    background: white;
    border: 0;
    outline: 0;
}

.histogram-pane {
    background-color: #F0F0F0;
}


/* #F5F5F5 */`, "",{"version":3,"sources":["webpack://./node_modules/janstatistics/lib/src/assets/css/statistics.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;EACf,+BAA+B;AACjC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iDAAiD,EAAE,+EAA+E;AACtI;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB,gBAAgB,EAAE,CAAA;IACpC,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;AACzC;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB,kBAAkB,EAAE,YAAY,CAAC,CAAA;IACnD,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;;IAErC,kBAAkB,kBAAkB,EAAE,YAAY,CAAC,CAAA;IACnD,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;IACrC,kBAAkB,iBAAiB,EAAE,CAAA;;IAErC;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;IAClD,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;AAChB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B,UAAU;AACV;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,YAAY","sourcesContent":["\n:root {\n    --first-color: #155263;\n    --second-color: #ff6f3c;\n    --third-color: #ff9a3c;\n    --fourth-color: #ffc93c;\n}\n\n.App {\n  text-align: center;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n  font-size: 11pt;\n  /* background-color: #F0F0F0; */\n}\n\ninput {\n    text-align: right;\n    width: 80px;\n    font-family: Roboto, 'Helvetica Neue', sans-serif; /* monospace digits ; see alse <Text style={{fontVariant: ['tabular-nums']}}> */\n}\n\nbutton.cross {\n    background-color: transparent;\n    border-width: 0em;\n    color: lightgrey;\n}\n\nbutton.cross:hover {\n    color: grey;\n}\n\nbutton.cross:active {\n    color: darkred;\n}\n\n\n.listingTable2 {\n    td:nth-child(1) { text-align: left; };\n    td:nth-child(2) { text-align: right; };\n    td:nth-child(3) { text-align: right; };\n}\n\n#frequencyTable td,\n#frequencyTable th {\n    padding-left: 5px;\n    padding-right: 5px;\n    border-left: solid 1px lightgray;\n}\n\n#frequencyTable th {\n    font-size: small;\n    background-color: #F0F0F0;\n}\n\n#frequencyTable {\n    border-collapse: collapse;\n    margin-top: 5px;\n    border: none;\n    td:nth-child(1) { text-align: center; border: none;};\n    td:nth-child(2) { text-align: right; };\n    td:nth-child(3) { text-align: right; };\n    td:nth-child(5) { text-align: right; };\n    td:nth-child(6) { text-align: right; };\n\n    th:nth-child(1) { text-align: center; border: none;};\n    th:nth-child(2) { text-align: right; };\n    th:nth-child(3) { text-align: right; };\n    th:nth-child(5) { text-align: right; };\n    th:nth-child(6) { text-align: right; };\n\n    tr:nth-child(even) {\n        background-color: #F9F9E1;\n    }\n}\n\n\ntable {\n    padding: 0px;\n    margin: 0px;\n    border-collapse: collapse;\n}\n\ntable th {\n    font-weight: 300;\n    padding-right: 3px;\n    margin: 0px;\n}\n\ntable td {\n    margin: 0px;\n    padding-left: 0px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-right: 2px;\n}\n\n#formBins label {\n    display: block;\n    width: 100px;\n    font-weight: 300;\n    font-size: small;\n}\n\n#formBins > div {\n    display: flex;\n    flex-flow: row wrap;\n}\n\n#formBins p {\n    text-align: right;\n    margin: 0px;\n    padding-bottom: 1.2px;\n    padding-top: 1.2px;\n    padding-right: 2px;\n    padding-left: 2px;\n    background-color: #F0F0F0;\n    border: 1px solid grey;\n    border-radius: 2px;\n    width: 82px;\n    box-sizing: content-box;\n}\n\n.freqIndicator {\n    fill: lightskyblue;\n    stroke: null;\n}\n\n.freqIndicatorDiv {\n    background-color: lightskyblue;\n    height: 12px;\n}\n\ndiv.card {\n    background-color: #FEFEFE; /*var(--fourth-color);*/\n    border-radius: 5px;\n    box-shadow: 0px 1px 2px #AEAEAE;\n    margin: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-bottom: 5px;\n    padding-top: 0px;\n    gap: 0px;\n}\n\np.cardTitle {\n    font-weight: 300;\n    text-align: left;\n    padding: 0px;\n    margin-top: 2px;\n}\n\n.popup {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #fff;\n    padding: 20px;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.popupWrapper {\n    display: flex;\n    align-items: flex-end;\n}\n\n.pig {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: end;\n}\n\n#formSettings > div {\n    display: flex;\n    flex-flow: row wrap;\n}\n\n#formSettings label {\n    /*display: block;*/\n    width: 100px;\n    font-weight: 300;\n    font-size: small;\n    padding-right: 2px;\n}\n\n#formSettings > input {\n    background-color: lightgray;\n    padding-right: 2px;\n    border: none;\n}\n\n/* todo solve either inheritance or composed class?*/\n.tab-active {\n  font-size: small;\n  /*padding: 10px 60px;*/\n  cursor: pointer;\n  opacity: 0.6;\n  background: white;\n  border: 0;\n  outline: 0;\n  border-bottom: 2px solid grey;\nopacity: 1;\n}\n\n.tab-inactive {\n    font-size: small;\n    /*padding: 10px 60px;*/\n    cursor: pointer;\n    opacity: 0.6;\n    background: white;\n    border: 0;\n    outline: 0;\n}\n\n.histogram-pane {\n    background-color: #F0F0F0;\n}\n\n\n/* #F5F5F5 */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
